import axios from '@axios';
import store from '@/store';

/**
 * Composable para gerenciar o registro diário de acesso da empresa
 */
export default function useDailyAccessLogger() {
  const LOCAL_STORAGE_KEY = 'last_access_log_date';

  /**
   * Verifica se já foi registrado acesso hoje
   * @returns {boolean}
   */
  const isAccessLoggedToday = () => {
    const lastLoggedDate = localStorage.getItem(LOCAL_STORAGE_KEY);
    const today = new Date().toISOString().split('T')[0];

    return lastLoggedDate === today;
  };

  /**
   * Atualiza a data do último acesso registrado
   */
  const updateLastLoggedDate = () => {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem(LOCAL_STORAGE_KEY, today);
  };

  /**
   * Registra o acesso da empresa no dia atual
   * @returns {Promise<void>}
   */
  const registerDailyAccess = async () => {
    try {
      // Só faz a requisição se o usuário estiver autenticado e ainda não tiver registrado acesso hoje
      if (!isAccessLoggedToday() && store.getters['auth/authenticated']) {
        await axios.post('/api/registro-acesso');
        updateLastLoggedDate();
      }
    } catch (error) {
      console.error('Erro ao registrar acesso diário:', error);
      // Mesmo em caso de erro, não vamos tentar novamente no mesmo dia
      // para evitar múltiplas requisições com falha
      updateLastLoggedDate();
    }
  };

  /**
   * Inicializa o sistema de registro de acesso
   */
  const initDailyAccessLogger = () => {
    registerDailyAccess();
  };

  return {
    registerDailyAccess,
    initDailyAccessLogger,
    isAccessLoggedToday,
  };
}
